import { handleBackgroundError } from '@/lib/error-handler';
import { SCHEMA_VERSIONS } from '../versions';
import { SessionEventSchema } from './session-events';
import type { SessionEvent } from './session-events';
import type { SessionEventV1 } from './versioned';

export const upcastSessionEventV1toV2 = (event: SessionEventV1) => {
  const upcasted = {
    ...event,
    version: SCHEMA_VERSIONS.SESSION_EVENT,
  } as SessionEvent;
  return upcasted;
};

export const upcastSessionEvent = (event: unknown): SessionEvent => {
  const parseResult = SessionEventSchema.safeParse(event);

  if (!parseResult.success) {
    const eventType = (event as { type?: string })?.type ?? 'unknown';
    const eventId = (event as { id?: string })?.id ?? 'unknown';
    const sessionId = (event as { sessionId?: string })?.sessionId ?? 'unknown';

    handleBackgroundError(
      new Error(
        `Invalid session event type "${eventType}" for event ${eventId} in session ${sessionId}. Error: ${parseResult.error.message}`,
      ),
      {
        operation: 'upcastSessionEvent',
        eventId,
        sessionId,
        eventType,
        zodError: parseResult.error,
      },
      'warn',
    );

    throw new Error(
      `Invalid session event type "${eventType}". This event may be from an older version or corrupted. Event ID: ${eventId}`,
    );
  }

  const parsed = parseResult.data;
  const version = parsed.version ?? 1;

  switch (version) {
    case 1: {
      return upcastSessionEventV1toV2(parsed as SessionEventV1);
    }
    case SCHEMA_VERSIONS.SESSION_EVENT: {
      return {
        ...parsed,
        version: SCHEMA_VERSIONS.SESSION_EVENT,
      };
    }
    default: {
      throw new Error(`Unsupported session event version: ${version}`);
    }
  }
};
